import React from 'react';
import { Route } from '../Routing/types';
import { HydrationIndexPage } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/hydration',
    element: <HydrationIndexPage />,
    private: true,
    title: dummy_t('hydration.navbarTitle'),
    mobileAppTabIdentifier: 'diet',
  },
];

export default routes;
